export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormScreen = {
        idlocation: '',
        location_name: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormScreen
    })
}